// extracted by mini-css-extract-plugin
module.exports = {"untilText":"az_VRc","closeText":"az_WRc"};